import { createApp } from 'vue'
import App from './App.vue'
import './styles/main.css'
import './styles/editor.css'

const app = createApp(App)

app.mount('#app')
